import { Component, inject, signal } from '@angular/core';
import { ActivatedRoute, ParamMap, RouterOutlet } from '@angular/router';
import { CustomTranslateModule } from './translate.module';
import { Subscription } from 'rxjs';
import { UnitService } from './services/unit.service';
import { SoundService } from './services/sound.service';
import { TokenService } from './services/token.service';
import { ToasterComponent } from '@kinomap-dev/ng-ui-lib/elements';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CustomTranslateModule, ToasterComponent],
  template: `
    <router-outlet />
    <kin-toaster />
  `,
  styleUrl: './app.scss',
})
export class App {
  protected readonly title = signal('Kinomap Player');
  subcription: Subscription | undefined;
  private route: ActivatedRoute = inject(ActivatedRoute);
  private unitService: UnitService = inject(UnitService);
  private soundService: SoundService = inject(SoundService);
  private tokenService: TokenService = inject(TokenService);

  ngOnInit(): void {
    this.tokenService.listenPostMessage();
    this.subcription = this.route.queryParamMap.subscribe((params: ParamMap) => {
      const unit: string | null = params.get('unit');
      const sound: string | null = params.get('sound');
      const token: string | null = params.get('userAccessToken');
      this.unitService.initFromQueryParam(unit);
      this.soundService.initFromQueryParam(sound);
      this.tokenService.initFromQueryParam(token);
    });
  }

  ngOnDestroy(): void {
    this.subcription?.unsubscribe();
  }
}
